import Tariff from './tariff.factory'
import TariffListService from './tariff-list.service'

const module = angular.module('ac.repositories.tariff', [])

module.factory('Tariff', Tariff).service('TariffListService', TariffListService)

export default module.name
